import { useTranslation } from 'react-i18next'

import X from '@/presentation/assets/svg/X.svg'
import Button from '@/presentation/components/Button'

interface ConfirmDivergencesModalProps {
  onConfirm: () => void
  onCancel: () => void
}

const ConfirmDivergencesModal = (props: ConfirmDivergencesModalProps) => {
  const { onConfirm, onCancel } = props

  const { t } = useTranslation()

  const handleConfirm = () => onConfirm()
  const handleClose = () => onCancel()

  return (
    <div
      onClick={handleClose}
      className="fixed inset-0 z-50 flex items-center justify-center bg-[#70707059] px-4"
    >
      <div
        className="flex max-w-[460px] flex-col rounded-lg bg-white p-4"
        onClick={e => e.stopPropagation()}
      >
        <div className="mb-1 flex items-center justify-between">
          <span className="text-lg text-gray-700">
            {t('ARE_YOU_SURE', 'Tem certeza?')}
          </span>

          <img src={X} onClick={handleClose} className="cursor-pointer" />
        </div>

        <hr className="mb-4" />

        <span className="mb-6 text-gray-700">
          {t(
            'YOU_CAN_MAKE_THIS_SUBMISSION_ONLY_ONCE',
            'Você poderá realizar este envio'
          )}{' '}
          <span className="font-bold text-error">
            {t('ONLY_ONCE', 'somente uma vez')}
          </span>
          .{' '}
          {t(
            'BEFORE_PROCEEDING_YOU_CAN_GO_BACK',
            'Antes de prosseguir você ainda pode voltar e registrar contestações de outros itens.'
          )}
          <br />
          <span className="mt-4 block">
            {t('WANT_TO_CONTINUE', 'Deseja continuar?')}
          </span>
        </span>

        <Button className="mb-4" onClick={handleConfirm}>
          {t('PROCEED', 'Prosseguir')}
        </Button>

        <Button onClick={handleClose} styleType="outline" colored>
          {t('RETURN', 'Voltar')}
        </Button>
      </div>
    </div>
  )
}

export default ConfirmDivergencesModal
